import type { StoreStatus } from "../types";

/** O horário é sempre o da loja (Guarulhos), não o do aparelho do cliente. */
const STORE_TIMEZONE = "America/Sao_Paulo";
export const OPENING_HOUR = 18;

const WEEKDAYS: Record<string, number> = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

const storeClock = (date: Date) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: STORE_TIMEZONE,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? "";
  return {
    diaSemana: WEEKDAYS[get("weekday")] ?? date.getDay(), // 0 (Dom) a 6 (Sab)
    horaAtual: Number(get("hour")),
    minutosAtuais: Number(get("minute")),
  };
};

export const checkStoreStatus = (date: Date = new Date()): StoreStatus => {
  const { diaSemana, horaAtual, minutosAtuais } = storeClock(date);

  const tempoAtual = horaAtual * 60 + minutosAtuais;
  const abertura = OPENING_HOUR * 60; // 18:00 (em minutos)

  // 1. Segunda-feira: Sempre FECHADO
  if (diaSemana === 0) return { isOpen: false, message: "Fechado — abre terça às 18h" };

  // 2. Define o fechamento: Sex, Sab e Dom às 00h (24:00). Outros dias às 23h.
  const fechamento = (diaSemana === 5 || diaSemana === 6 || diaSemana === 0)
    ? 24 * 60
    : 23 * 60;

  if (tempoAtual < abertura) return { isOpen: false, message: "Fechado — abre hoje às 18h" };
  if (tempoAtual >= fechamento) return { isOpen: false, message: "Fechado — abre amanhã às 18h" };

  return { isOpen: true, message: "Aberto Agora" };
};
